import { useSelector } from 'react-redux'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import InputCustom from '../../components/atoms/input/InputCustom'
import CommonModal from '../../components/atoms/modal/CommonModal'
import styles from './ChatPageV2.module.scss'
import { Avatar } from '@mui/material'
import { useState } from 'react'
import AddIcon from '@mui/icons-material/Add'

export default function ChatMembersModal({
	open,
	handleClose,
	setNewChatType,
	statusMap,
	onSuccess,
}) {
	const groupMembers = useSelector((s) => s.group.groupMembers)
	const onlineUsers = useSelector((s) => s.auth.onlineUsers)

	const [searchQuery, setSearchQuery] = useState('')

	const filtered = groupMembers.filter((m) =>
		(m.businessName || m.preferredName || `${m.firstName} ${m.lastName}`)
			.toLowerCase()
			.includes(searchQuery.toLowerCase().trim())
	)

	const handleSearchQueryChange = (e) => {
		setSearchQuery(e.target.value)
	}

	return (
		<CommonModal open={open} handleClose={handleClose} heading="Members">
			<div className={styles.modalBody}>
				<div
					className={`${styles.groupSearchContainer} ${styles.chatMembersModal}`}
				>
					<InputCustom
						value={searchQuery}
						type="text"
						name="search"
						id="search"
						placeholder="Search Members"
						error={false}
						searchIcon={true}
						onChange={handleSearchQueryChange}
					/>

					<ButtonCustom
						onClick={() => setNewChatType('group')}
						style={{ padding: '11px 11px' }}
					>
						<AddIcon
							sx={{
								width: '16px !important',
								height: '16px !important',
							}}
						/>
					</ButtonCustom>
				</div>

				<ul className={styles.chatList}>
					{filtered?.map((user) => (
						<li key={user._id} className={styles.chatItem}>
							<div
								className={`${styles.avatar} ${statusMap[onlineUsers.includes(user._id)]}`}
							>
								<Avatar
									src={user.avatar}
									alt="avatar"
									className={styles.avatar__img}
								/>
							</div>

							<div className={styles.chatInfo}>
								<h4 className={styles.userName}>
									{user.businessName ||
										user.preferredName ||
										`${user.firstName} ${user.lastName}`}
								</h4>
								<p className={styles.lastMessage}>{user.__t}</p>
							</div>
							{/* <ButtonCustom
                                size="lg"
                                variant="outlined"
                                className={`${styles.timeStamp} ${styles.sidebarButton}`}
                                onClick={onSuccess}
                            >
                                <img src="/images/chat-icon.svg" alt="chat" />
                                Chat now
                            </ButtonCustom> */}
						</li>
					))}
				</ul>
			</div>
		</CommonModal>
	)
}
